import Rete from 'rete'

import { lang } from '../../assets/lang'

export default {
  install(editor) {
    let lastConnection = null;
    
    editor.on('connectionremoved', c => {
      lastConnection = c;
      setTimeout(() => lastConnection = null, 0)
    })
        
    editor.on('connectioncreate', (c) => {
      const nodes = editor.toJSON().nodes
      nodes[c.input.node.id].inputs[c.input.key].connections.push({ node: c.output.node.id, output: c.output.key })
      
      const recurrectNode = new Rete.Recursion(nodes).detect()
      
      if(recurrectNode) {
        alert(lang.plugin_recursion_problem)
        if(lastConnection)
          editor.connect(lastConnection.output, lastConnection.input)
        return false
      }
    })
  }
}